import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ULTRA_SERVICE_ENUM, UltraServiceUrlMap } from "../utils/data";
import { ServiceLocationModal } from "../components/modal/serviceLocationModal/ServiceLocationModal";

export const useExapandableFabActions = () => {
  const navigate = useNavigate();

  const [serviceLocationDialogData, setServiceLocationDialogData] = useState<{
    visible: boolean;
    onConfirm: (locationId: number) => void;
    description?: string;
  }>({
    visible: false,
    onConfirm: () => {},
    description: undefined,
  });

  const hideServiceLocationDialog = () => {
    setServiceLocationDialogData({
      visible: false,
      onConfirm: () => {},
      description: undefined,
    });
  };

  const getUrlToNavigate = (service: number, location: number) => {
    const url =
      UltraServiceUrlMap.get(service)?.find((item) => {
        return item.id === location;
      })?.url ?? "/";

    // Check if it's an external URL (starts with http:// or https://)
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.location.href = url;
      return "";
    }
    return url;
  };

  const handleServiceModalActionButtons = useCallback(
    (service: number, description?: string) => {
      setServiceLocationDialogData({
        visible: true,
        description: description,
        onConfirm: (locationId: number) => {
          hideServiceLocationDialog();
          navigate(getUrlToNavigate(service, locationId));
        },
      });
    },
    [navigate]
  );

  const renderServiceLocationModal = useMemo(() => {
    return (
      <ServiceLocationModal
        visible={serviceLocationDialogData.visible}
        onConfirm={serviceLocationDialogData.onConfirm}
        onClose={hideServiceLocationDialog}
        description={serviceLocationDialogData.description}
      />
    );
  }, [serviceLocationDialogData]);

  const ExpandableFabButtons = useMemo(() => {
    return [
      {
        id: ULTRA_SERVICE_ENUM.BOOK_COURT,
        title: "Book Court",
        onClick: () => {
          handleServiceModalActionButtons(
            ULTRA_SERVICE_ENUM.BOOK_COURT,
            "Please choose location for court booking"
          );
        },
      },
      // {
      //   id: ULTRA_SERVICE_ENUM.FULL_BOOKING,
      //   title: "Full Booking",
      //   onClick: () => {
      //     handleServiceModalActionButtons(
      //       ULTRA_SERVICE_ENUM.FULL_BOOKING,
      //       "Please choose location for full booking"
      //     );
      //   },
      // },
      {
        id: ULTRA_SERVICE_ENUM.BOOK_CLINIC,
        title: "Book Clinic",
        onClick: () => {
          handleServiceModalActionButtons(
            ULTRA_SERVICE_ENUM.BOOK_CLINIC,
            "Please choose location for clinic booking"
          );
        },
      },
      {
        id: ULTRA_SERVICE_ENUM.BOOK_LESSON,
        title: "Book Lesson",
        onClick: () => {
          handleServiceModalActionButtons(
            ULTRA_SERVICE_ENUM.BOOK_LESSON,
            "Please choose location for lesson booking"
          );
        },
      },
      {
        id: ULTRA_SERVICE_ENUM.BOOK_EVENT,
        title: "Book Event",
        onClick: () => {
          handleServiceModalActionButtons(
            ULTRA_SERVICE_ENUM.BOOK_EVENT,
            "Please choose location for event booking"
          );
        },
      },
      {
        id: ULTRA_SERVICE_ENUM.BOOK_TOURNAMENT,
        title: "Book Tournament",
        onClick: () => {
          handleServiceModalActionButtons(
            ULTRA_SERVICE_ENUM.BOOK_TOURNAMENT,
            "Please choose location for tournament booking"
          );
        },
      },
    ];
  }, [handleServiceModalActionButtons]);

  return {
    ExpandableFabButtons,
    renderServiceLocationModal,
  };
};
